export class storeSchedulerAction {
    static readonly type = '[schedulerObj] schedulerObj';

    constructor(public payload: any) {
    }
}
export class storeTypeAction {
    static readonly type = '[type] type';

    constructor(public payload: any) {

    }
}